import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia';

import ssoPlugin from '@psu/sso'
import '@psu/sso/style.css'

export let app = createApp(App)

const pinia = createPinia();
app.use(pinia)

app.use(ssoPlugin)
app.config.globalProperties.$appName = "BIO_DATA" //"EXP_BIO_DATA";
app.config.globalProperties.$fintiPath = "people/v1/bio_data/web" // Default for $fintiCall()
app.config.globalProperties.$envName = import.meta.env.VITE_APP_ENV || "test";  // {local, dev, test, prod}
app.config.globalProperties.$proxyRoles = ['proxy', 'proxy_initial', 'proxy_employee', 'proxy_employee_initial', 'proxy_student', 'proxy_student_initial']

app.use(router)

app.mount('#app')
